const getTransitionStyles = (state: string, direction: "left" | "right" | "up" | "down") => {
  const exitOffset = direction === "right" || direction === "down" ? "-100%" : "100%";
  const enterOffset = direction === "right" || direction === "down" ? "100%" : "-100%";
  const transformProperty = direction === "left" || direction === "right" ? "translateX" : "translateY";

  const styles: Record<string, React.CSSProperties> = {
    entering: { transform: `${transformProperty}(0)`, transition: "transform 200ms ease-out" },
    entered: { transform: `${transformProperty}(0)` },
    exiting: { transform: `${transformProperty}(${exitOffset})`, transition: "transform 200ms ease-out" },
    exited: { transform: `${transformProperty}(${enterOffset})` },
  };

  return styles[state] || {};
};

export default getTransitionStyles;
